import styled, { css } from "styled-components"
import Breakpoints from "../shared/breakpoints"
import { FadeInBottom } from "../shared/keyframes.style"

export const HeroOverlay = css`
  background-color: var(--tricorn-black);
  mix-blend-mode: multiply;
`

export const TestimonialContainer = styled.div`
  margin: 64px auto 0 auto;
  max-width: 1440px;
  padding: 0 20px;

  @media (min-width: ${Breakpoints.lg}) {
    margin: 96px auto 0 auto;
    width: 55vw;
    & > p {
      max-width: 900px;
    }
  }

  & * {
    text-align: center !important;
    margin-bottom: 0;
    padding: 0;
  }

  & p {
    padding-top: 32px;
  }

  p,
  img {
    animation: ${(props) => !props.disableAnimations && FadeInBottom};
    animation-play-state: ${(props) =>
      props.isVisible ? "running" : "paused"};

    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 0.3s;
    animation-fill-mode: both;
  }
`
